export default __webpack_public_path__ + "static/media/ossscreen14.df1daf63.png";